// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"_7Y2au","notificationsFill":"_7C-OK"};